'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _handlers = require('./handlers');

var _bindings = require('./bindings');

var _AddToCart = require('components/AddToCart');

var _StickyATC = require('../../components/StickyATC');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = exports.init = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // setLoaderTimeout();

            (0, _handlers.initProductGallery)();
            _context.next = 3;
            return (0, _handlers.initProductData)();

          case 3:
            _context.next = 5;
            return (0, _handlers.initFlowData)();

          case 5:

            // disableLoader();
            (0, _bindings.bindActions)();
            (0, _AddToCart.bind)();
            (0, _handlers.updateProduct)();
            (0, _StickyATC.init)();

          case 9:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function init() {
    return _ref.apply(this, arguments);
  };
}();